import React, { useState } from "react";
import TermsModal from "./TermsModal";

const TermsLink = ({ label = "Terms of Use & Privacy Policy" }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
        style={{
          color: "#007bff",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {label}
      </span>

      <TermsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default TermsLink;
